import { buildCsvFilename, downloadCsv } from '@/utils/file'
import { CsvField } from '@/utils/file/download-csv.utils'

interface ExportCsvParams<T> {
  buildingName?: string
  data: T[]
  fields: CsvField[]
  page: string
}

export const exportCsv = <T>({ buildingName, data, fields, page }: ExportCsvParams<T>) =>
  downloadCsv({
    data,
    fields,
    filename: buildCsvFilename({ building: buildingName, date: new Date(), page }),
  })
